import styled, { css } from 'styled-components';
import { Button } from 'components/Button';
import { FormItem } from 'components/UI/Form';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: var(--v3-banner-title);
`;

export const PriceWrapper = styled.div`
  display: flex;
  background: var(--v3-black-4);
  padding: 20px;
  border-radius: 16px;
`;

export const StripeWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const EvocaSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const CartFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--v3-black-0);
  padding: 16px 24px 24px;
  z-index: 10;
`;

export const PurchaseButton = styled(Button)`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    border-color: var(--v3-black);
    background-color: var(--v3-black-100);
    color: var(--v3-text-color-inverse);
  }
`;
export const PaymentWrapper = styled.div`
  padding: 7px;
  .ant-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const FormItemWide = styled(FormItem)`
  grid-column: 1 / 3;
`;

export const Label = styled.h3`
  margin: 0;
  color: var(--v3-text-color);
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.3px;
  &::after {
    content: '*';
    position: relative;
    top: -3px;
    color: var(--v3-error-color);
    font-size: 14px;
  }
`;

export const CartTileWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 64px auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    'media info'
    'media-placeholder price';
  gap: 16px;
  padding: 12px 20px;
  background: var(--v3-black-0);
  border-radius: 12px;
`;

export const NftMedia = styled.img<{ $mediaLoaded: boolean }>`
  grid-area: media-placeholder;
  width: 64px;
  height: 0;
  border-radius: 16px;

  ${({ $mediaLoaded }) =>
    $mediaLoaded &&
    css`
      grid-area: media;
      height: 64px;
    `}
`;

export const CartTileInfo = styled.div`
  grid-area: info;
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-template-rows: auto auto;
  gap: 4px;
`;

export const CartTileTitle = styled.div`
  grid-column: 1 / 3;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  word-break: break-word;
  color: var(--v3-text-color);
`;

export const CartTilePriceWrapper = styled.div`
  grid-area: price;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid var(--v3-black-2);
  padding: 8px 0 4px;
`;

export const CartTilePriceLabel = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--v3-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CartTilePrice = styled.div`
  color: var(--v3-text-color);
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
`;
